import { findIndex, some } from 'lodash';

export default function getActiveStepIndex(path = '', steps = []) {
  const activeStep = findIndex(steps, (step) => {
    if (step.routeRegex) {
      return step.routeRegex.test(path);
    }
    return some(step.routes, ['route', path]);
  });
  return activeStep;
}
